import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import entityReducerFactory from './factories/entityReducerFactory';
import documentConstantsFactory from '../constants/documentConstantsFactory';
import applyReducer from './applyReducer';

// import documentTagSelectDocumentConstants from
//   '../constants/documentTagSelectDocumentConstants';

const entityReducer = entityReducerFactory('documentTagSelectDocument');
const documentConstants = documentConstantsFactory('DOCUMENT');
const initState = _objectSpread({}, entityReducer.initState);
const documentChange = (state, action) => {
  let result = state;
  if (action.path === 'cloudDocument/documentTags') {
    var _action$data;
    const isNew = (_action$data = action.data) !== null && _action$data !== void 0 && _action$data.length // eslint-disable-next-line no-underscore-dangle
    ? action.data.filter(docTag => docTag.__isNew__).length > 0 : false;
    if (isNew) {
      result = _objectSpread(_objectSpread({}, state), {}, {
        indexQuery: _objectSpread(_objectSpread({}, state.indexQuery), {}, {
          initialized: false
        })
      });
    }
  }
  return result;
};
const reducers = _objectSpread(_objectSpread({}, entityReducer.reducers), {}, {
  [documentConstants.CHANGE]: documentChange
});
export default applyReducer(reducers, initState);